import * as r from 'ramda';
import { v4 as uuid } from 'uuid';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as $auth from 'modules/auth';

export const useDeviceID = () => {
  const dispatch = useDispatch();
  const currentDeviceId = useSelector($auth.getDeviceId);

  useEffect(() => {
    if (r.isNil(currentDeviceId)) {
      dispatch($auth.setDeviceId(uuid()));
    }
  }, [currentDeviceId, dispatch]);
};
